import React, { FC } from "react";
import { QueryClient, QueryClientProvider } from "react-query";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { ConfigProvider } from "./providers/configProvider/ConfigProvider";
import ConfigChecker from "./ConfigChecker";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const App: FC = () => (
  <QueryClientProvider client={queryClient}>
    <ConfigProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ConfigChecker />
      </LocalizationProvider>
    </ConfigProvider>
  </QueryClientProvider>
);

export default App;
